/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTemplateResponse
 */
export interface EmailTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof EmailTemplateResponse
     */
    content: string;
}

/**
 * Check if a given object implements the EmailTemplateResponse interface.
 */
export function instanceOfEmailTemplateResponse(value: object): value is EmailTemplateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function EmailTemplateResponseFromJSON(json: any): EmailTemplateResponse {
    return EmailTemplateResponseFromJSONTyped(json, false);
}

export function EmailTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'subject': json['subject'],
        'content': json['content'],
    };
}

export function EmailTemplateResponseToJSON(json: any): EmailTemplateResponse {
    return EmailTemplateResponseToJSONTyped(json, false);
}

export function EmailTemplateResponseToJSONTyped(value?: EmailTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'subject': value['subject'],
        'content': value['content'],
    };
}

